import { render, staticRenderFns } from "./SlugData.vue?vue&type=template&id=83b122a6&"
import script from "./SlugData.vue?vue&type=script&lang=js&"
export * from "./SlugData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports